<template>
  <div class="container-fluid">
    <div class="contact-container">
      <h2 class="contact-title">Contact Us!</h2>
    </div>
    <div class="container d-flex">
      <div class="row justify-content-center mx-auto w-100">
        <div class="col-md-2 text-center contact-options">
          <div>
            <img
              class="vector"
              style="height: fit-content"
              src="/assets/Vector.png"
              alt="Image"
            />
            <h6 class="heading">Email</h6>
            <div>
              <a href="mailto:careers@cowlar.com" class="info-text"
                >careers@cowlar.com</a
              >
            </div>
          </div>
        </div>
        <div class="col-auto text-center horizontal-line"></div>
        <div class="col-md-2 text-center contact-options">
          <span>
            <img
              class="vector vector-2"
              src="/assets/Vector1.png"
              alt="Image"
            />
          </span>

          <h6 class="vertical-line"></h6>
          <h6 class="heading2">Pakistan</h6>

          <div class="d-flex">
            <a
              href="https://www.google.com/maps/place/Cowlar+Design+Studio/@33.7192344,73.0514502,17z/data=!3m2!4b1!5s0x38dfbfa6491301bd:0x192733485df0677e!4m6!3m5!1s0x38dfbf69f1c13bc5:0x8078f2bb7bd09520!8m2!3d33.71923!4d73.0540251!16s%2Fg%2F11p16p4x22?shorturl=1"
              target="_blank"
              ><p class="info-text-small">F-7 Markaz, Islamabad, Pakistan</p>
            </a>
          </div>
        </div>
        <div class="col-auto text-center horizontal-line"></div>
        <div class="col-md-2 text-center contact-options">
          <img class="vector vector-2" src="/assets/Vector1.png" alt="Image" />

          <h6 class="vertical-line"></h6>
          <h6 class="heading2">USA</h6>

          <div class="d-flex">
            <a
              href="https://www.google.com/maps/place/88+Union+Ave+Suite+200,+Memphis,+TN+38103,+USA/@35.143551,-90.0565286,17z/data=!3m1!4b1!4m6!3m5!1s0x87d57e95d5d6aaab:0x87f159273cc2ae5a!8m2!3d35.1435466!4d-90.0539537!16s%2Fg%2F11mhjxfkv0?shorturl=1"
              target="_blank"
              ><p class="info-text-small">Memphis, TN, United States</p>
            </a>
          </div>
        </div>
        <div class="col-auto text-center horizontal-line"></div>
        <div class="col-md-2 text-center contact-options">
          <img class="vector vector-2" src="/assets/Vector1.png" alt="Image" />

          <h6 class="vertical-line"></h6>
          <h6 class="heading2">Qatar</h6>

          <div class="d-flex">
            <a
              href="https://google.com/maps/place/doha+qatar+west+bay/data=!4m2!3m1!1s0x3e45c4c7694e3955:0x8a2357f7fb6c9b8e?sa=X&ved=1t:155783&ictx=111"
              target="_blank"
              ><p class="info-text-small">West Bay, Doha, Qatar</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- LinkedIn Section -->
    <div class="linkedin-pill-section">
      <a
        href="https://www.linkedin.com/company/cowlar-design/"
        target="_blank"
        class="linkedin-pill"
      >
        <div class="linkedin-pill-content">
          <img
            src="@/assets/linkedin.svg"
            alt="LinkedIn"
            class="linkedin-pill-icon"
          />
          <div class="linkedin-pill-text">
            <span class="linkedin-pill-title">Follow us on LinkedIn!</span>
          </div>
          <span class="linkedin-pill-button">Follow</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import "vue3-carousel/dist/carousel.css";

export default {
  name: "RecentWork",
  components: {},
  setup() {
    const router = useRouter();
    return { router };
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
  text-decoration: none;
}

.container {
  box-shadow: 0 0.375rem 1.25rem rgba(0, 0, 0, 0.5);
  background: #2d2d2e;
  border-radius: 0.625rem;
  padding: 2rem;
}

h6 {
  color: #b5b8ba;
}

.contact-title {
  text-align: center;
  margin-bottom: 1.5rem;
}

.contact-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  align-self: flex-start;
}

.heading,
.heading2 {
  font-size: 1.125rem;
  margin-bottom: 0;
  opacity: 1 !important;
  margin-top: 0.5rem;
}

.info-text,
.info-text-small {
  font-size: 0.875rem;
  opacity: 0.6;
  margin: 0;
  color: #b5b8ba;
}

.info-text-small {
  text-align: center;
  width: 100%;
  padding: 0 0.5rem;
}

.vector,
.vector-2 {
  margin-top: 0;
  height: 1.875rem;
  width: 1.5625rem;
}

.vector:hover,
.vector-2:hover {
  cursor: pointer;
  opacity: 0.5;
}

.horizontal-line {
  width: 0.0625rem;
  height: 7.5rem;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0 1rem;
  opacity: 0.5;
  padding: 0;
}

/* LinkedIn Pill Styles */
.linkedin-pill-section {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  padding: 0 2rem;
}

.linkedin-pill {
  background: #0077b5;
  border-radius: 3.125rem;
  padding: 1rem 1.5rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 119, 181, 0.3);
  transition: all 0.3s ease;
  max-width: 37.5rem;
  width: 100%;
  display: block;
  text-decoration: none;
  color: inherit;
}

.linkedin-pill:hover {
  transform: translateY(-0.125rem);
  box-shadow: 0 0.375rem 1.25rem rgba(0, 119, 181, 0.4);
  text-decoration: none;
  color: inherit;
}

.linkedin-pill-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
}

.linkedin-pill-icon {
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}

.linkedin-pill-text {
  flex: 1;
}

.linkedin-pill-title {
  font-weight: 600;
  font-size: 1rem;
  color: white;
}

.linkedin-pill-button {
  background: white;
  color: #0077b5;
  padding: 0.5rem 1rem;
  border-radius: 1.5625rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: inline-block;
}

.linkedin-pill:hover .linkedin-pill-button {
  background: rgba(255, 255, 255, 0.95);
  transform: scale(1.05);
  color: #005885;
}

/* Mobile Responsive */
@media (max-width: 48rem) {
  .container {
    padding: 1rem;
  }

  .row {
    flex-direction: column;
  }

  .contact-options {
    margin-bottom: 2rem;
  }

  .horizontal-line {
    width: 100%;
    height: 0.0625rem;
    margin: 1rem 0;
  }

  .info-text-small {
    font-size: 0.75rem;
  }

  .contact-title {
    font-weight: 700 !important;
    font-size: 1.5rem !important;
    line-height: 110%;
    letter-spacing: -0.01rem;
  }

  .heading,
  .heading2 {
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 120%;
    margin-top: 1rem !important;
    margin-bottom: 0.5rem !important;
  }

  .linkedin-pill-section {
    margin-top: 1.5rem;
    padding: 0 1rem;
  }

  .linkedin-pill {
    padding: 0.875rem 1.25rem;
  }

  .linkedin-pill-content {
    gap: 0.75rem;
  }

  .linkedin-pill-icon {
    width: 1.75rem;
    height: 1.75rem;
  }

  .linkedin-pill-title {
    font-size: 0.9rem;
  }

  .linkedin-pill-button {
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
  }
}

@media (min-width: 48.0625rem) {
  .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .contact-options {
    flex: 1;
  }

  .horizontal-line {
    align-self: stretch;
    margin-top: 1rem;
  }
}
</style>
